module.exports = __webpack_public_path__ + "img/rolunk_3.0ebfae75.jpg";